import React from 'react';
import styled from 'styled-components';
import { useUserSettingsSelector } from '../../../redux/selectorHooks';
import { TagOption } from '../../../utils/apollo/graphqlSchema';
import { DefaultView } from '../../../utils/userSettings';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const EmptyPanelStack = ({ tags }: { tags: TagOption[] }) => {
  const defaultView = useUserSettingsSelector('defaultView');

  const getLabelForTag = (tag: TagOption) => {
    switch (tag) {
      case TagOption.BasicEvent:
      case TagOption.AnyEvent:
      case TagOption.VirtualEvent:
        return 'Events';
      case TagOption.Field:
        return 'Fields';
      case TagOption.Filter:
        return 'Filters';
      case TagOption.SimpleMeasure:
      case TagOption.CompoundMeasure:
        return 'Measures';
      case TagOption.SimpleCohort:
      case TagOption.CompoundCohort:
        return 'Cohorts';
      case TagOption.DateBucketDef:
      case TagOption.EnumBucketDef:
      case TagOption.RangeBucketDef:
        return 'Buckets';
      default:
        return 'Results';
    }
  };

  return (
    <Container>
      No {getLabelForTag(tags[0])} found
      {defaultView === DefaultView.ManagedView ? ' in Managed View' : ''}
    </Container>
  );
};

export default EmptyPanelStack;
